export default __webpack_public_path__ + "media/placeholder/avatar-2a369d61.png";